import { Col, Modal, Row } from "antd";
import React from "react";
import CommonButton from "../../Components/Buttons/CommonButton";
import classes from "../Modal.module.css";

function ParameterListModal({
  open,
  closable,
  onCancel,
  Data,
}: {
  open: boolean;
  closable: boolean;
  onCancel: () => void;
  Data: any;
}) {
  return (
    <>
      <Modal open={open} closable={closable} width={1000} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Parameter List</h4>

          <Row gutter={[16, 16]}>
            {JSON.parse(Data)?.map((data: any) => {
              for (const key in data) {
                return (
                  <Col xxl={6} lg={6} sm={8} xs={12}>
                    <p
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {[key]}{" "}
                    </p>
                    <p
                      style={{
                        color: "grey",
                        fontSize: 12,
                        fontWeight: 600,
                        textAlign: "center",
                        margin: 0,
                      }}
                    >
                      {data[key]}
                    </p>
                  </Col>
                );
              }
            })}
          </Row>
          <div className={classes.modal_button_container}>
            <CommonButton
              name="Close"
              type="button"
              onClick={() => onCancel()}
              style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ParameterListModal;
